export const payload = {
  receiveMutation: 'RECEIVE_BP',
  receiveMetadataMutation: 'RECEIVE_BP_METADATA',
  savingMutation: 'SAVING_BP',
  incrementMutation: 'INCREMENT_BP_COUNT',
  updatingMutation: 'UPDATING_BP',
  resetMetaMutation: 'RESET_BP_META',
  clearMutation: 'CLEAR_BP_STATE',
  moduleName: 'bp',
  endpoint: 'bps'
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Bps/actionPayload.js